import React from 'react';

var _path;

var SvgFraudProtectUnprotectedMajor = function SvgFraudProtectUnprotectedMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.493 2.879C3.757 2.562 6.757 1.616 9.128.233a1.733 1.733 0 0 1 1.728-.004c2.369 1.354 5.502 2.29 7.65 2.628.818.128 1.491.81 1.491 1.638v.501c.031 6.043-.48 11.332-9.472 14.903a1.45 1.45 0 0 1-1.062 0C.478 16.328-.029 11.04.001 4.996L0 4.499c-.002-.83.672-1.505 1.493-1.62zm7.8 2.414A1 1 0 0 0 9 6v4a1 1 0 1 0 2 0V6a1 1 0 0 0-1.707-.707zm0 8a1 1 0 1 0 1.414 1.414 1 1 0 0 0-1.414-1.414z"
  })));
};

export { SvgFraudProtectUnprotectedMajor as S };
